import { render, staticRenderFns } from "./ReportedVolunteer.vue?vue&type=template&id=13dbaa80"
import script from "./ReportedVolunteer.vue?vue&type=script&lang=js"
export * from "./ReportedVolunteer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports